<header>
    <div class="header-row logo-row">
        <img src="/assets/innogy-icons/logo_black.svg" aria-hidden="true">
    </div>

    <div class="header-row secondary-row">
        <h1 data-qa="tnb-header">
            <a [routerLink]="['/']">
                TNB-Portal Kaskade
            </a>

            <div class="user-role">
            @if (user$ | async; as profile) {
                <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
                @if (profile.netzbetreiberType === 'WESTNETZ') {
                    <small data-qa="loggedin-netzbetreiber-name">
                        Westnetz
                    </small>
                } @else {
                    <small data-qa="loggedin-netzbetreiber-name">
                        {{ this.selectedTeilgebiet?.name }}
                    </small>
                    @if (profile.teilgebieteInfos?.length > 1) {
                        <small> - </small>
                        <small data-qa="loggedin-netzbetreiber-teilgebiet">
                            {{ this.selectedTeilgebiet?.teilgebiet }}
                        </small>
                    }
                }
            }
            </div>
        </h1>

        <nav class="tnb-header-menu">

            @if (user$ | async; as profile) {
                <button matButton="filled"
                        class="menu-button"
                        [class.menu-open]="menuTrigger.menuOpen"
                        data-qa="menu-button"
                        [matMenuTriggerFor]="menu"
                        #menuTrigger="matMenuTrigger">
                    <mat-icon [svgIcon]="menuTrigger.menuOpen ? 'innogy_picto_close' : 'innogy_picto_menu'"></mat-icon>
                    {{ menuTrigger.menuOpen ? 'Schließen' : 'Menü' }}
                </button>
                <mat-menu #menu="matMenu" class="main-menu">
                    @if (profile.teilgebieteInfos?.length > 1) {
                        <button mat-menu-item
                                data-qa="menu-teilgebietsauswahl"
                                [matMenuTriggerFor]="teilgebietSubMenu">
                            <mat-icon svgIcon="innogy_picto_cogeneration-unit"></mat-icon>
                            <span>Teilgebietsauswahl</span>
                        </button>
                        <hr>
                    }
                    <a mat-menu-item
                       data-qa="menu-dashboard"
                       routerLinkActive #rla="routerLinkActive"
                       [attr.aria-current]="rla.isActive ? 'page' : null"
                       routerLink="/dashboard">
                        <mat-icon svgIcon="innogy_picto_home_large"></mat-icon>
                        <span>Dashboard</span>
                    </a>
                    @if (shouldSeeErzeugungsanlagenFeatureWestnetzAlways(profile)) {
                        <a mat-menu-item
                           data-qa="menu-list"
                           routerLinkActive #rla="routerLinkActive"
                           [attr.aria-current]="rla.isActive ? 'page' : null"
                           [routerLink]="['/erzeugungsanlage/list']">
                            <mat-icon svgIcon="innogy_picto_windmill"></mat-icon>
                            <span>Erzeuger Liste</span>
                        </a>
                    }
                    @if (profile.netzbetreiberType === 'WESTNETZ') {
                        <a mat-menu-item
                           data-qa="netzbetreiber-list"
                           routerLinkActive #rla="routerLinkActive"
                           [attr.aria-current]="rla.isActive ? 'page' : null"
                           [routerLink]="['/netzbetreiber/list']">
                            <mat-icon svgIcon="innogy_picto_pylon"></mat-icon>
                            <span>Netzbetreiber Liste</span>
                        </a>
                    }
                    <a mat-menu-item
                       [routerLink]="['/netzzuordnung']"
                       routerLinkActive #rla="routerLinkActive"
                       [attr.aria-current]="rla.isActive ? 'page' : null"
                       data-qa="netzzuordnungen-list">
                        <mat-icon>list</mat-icon>
                        <span>Netzzuordnungen Liste</span>
                    </a>
                    @if (authenticationService.isWestnetzAdmin(profile)) {
                        <a mat-menu-item
                           data-qa="netzbetreiber-create"
                           [routerLink]="['/netzbetreiber/list']"
                           [queryParams]="{'createnew':true, 'openedInSideNav': true}"
                           [queryParamsHandling]="'merge'"
                        >
                            <mat-icon svgIcon="innogy_picto_c-plus"></mat-icon>
                            <span>Neuer Netzbetreiber</span>
                        </a>
                    }
                    @if (shouldSeeErzeugungsanlagenFeatureOnlyStadtwerk(profile)) {
                        <a mat-menu-item
                           data-qa="menu-export"
                           (click)="export()"
                        >
                            <mat-icon>cloud_upload</mat-icon>
                            <span>Export</span>
                        </a>
                    }
                    @if (shouldSeeErzeugungsanlagenFeatureOnlyStadtwerk(profile)) {
                        <a mat-menu-item
                           data-qa="menu-import"
                           (click)="importWizardDialogService.openImportWizard(wizardComponent)"
                        >
                            <mat-icon>cloud_download</mat-icon>
                            <span>Import</span>
                        </a>
                    }
                    @if (shouldSeeErzeugungsanlagenFeatureOnlyStadtwerk(profile)) {
                        <a mat-menu-item
                           data-qa="menu-add-erzeugungsanlage"
                           [routerLink]="['/erzeugungsanlage/list']"
                           [queryParams]="{'createnew':true}"
                           [queryParamsHandling]="'merge'"
                        >
                            <mat-icon svgIcon="innogy_picto_c-plus"></mat-icon>
                            <span>Neue Erzeugungsanlage</span>
                        </a>
                    }
                    <a mat-menu-item
                       data-qa="datenabfragen-menuitem"
                       routerLinkActive #rla="routerLinkActive"
                       [attr.aria-current]="rla.isActive ? 'page' : null"
                       [routerLink]="['/datenabfrage/datenabfrage-page']"
                       [queryParamsHandling]="'merge'">
                        <mat-icon>assignment</mat-icon>
                        <span>Datenabfragen ATS</span>
                    </a>
                    @if (authenticationService.isWestnetzAdmin(profile)) {
                        <a mat-menu-item
                           data-qa="menu-settings"
                           routerLinkActive #rla="routerLinkActive"
                           [attr.aria-current]="rla.isActive ? 'page' : null"
                           [routerLink]="['/settings']"
                           [queryParamsHandling]="'merge'">
                            <mat-icon svgIcon="innogy_picto_control-panel"></mat-icon>
                            <span>Einstellungen</span>
                        </a>
                    }
                    @if (profile.netzbetreiberType === 'STADTWERK') {
                        <a mat-menu-item
                           data-qa="menu-kontakt-westnetz"
                           routerLinkActive #rla="routerLinkActive"
                           [attr.aria-current]="rla.isActive ? 'page' : null"
                           [routerLink]="['/kontakt']"
                        >
                            <mat-icon svgIcon="innogy_picto_person_info"></mat-icon>
                            <span>Kontaktdaten Westnetz</span>
                        </a>
                    }
                    @if (profile.netzbetreiberType === 'STADTWERK') {
                        <a mat-menu-item
                           data-qa="menu-mein-kontaktdaten"
                           routerLinkActive #rla="routerLinkActive"
                           [attr.aria-current]="rla.isActive ? 'page' : null"
                           [routerLink]="['netzbetreiber','detail']"
                           [queryParams]="{stadtwerkeId: selectedTeilgebiet?.stadtwerkeId, openedInSideNav: false}">
                            <mat-icon svgIcon="innogy_picto_person"></mat-icon>
                            <span>Meine Kontaktdaten</span>
                        </a>
                    }
                    <a mat-menu-item
                       data-qa="menu-logout-button"
                       (click)="logout()">
                        <mat-icon svgIcon="innogy_picto_power_on_off"></mat-icon>
                        <span>Abmelden</span>
                    </a>
                </mat-menu>
                <mat-menu #teilgebietSubMenu="matMenu" class="teilgebiet-menu" xPosition="before">
                    @for (teilgebiet of profile.teilgebieteInfos; track teilgebiet.stadtwerkeId) {
                        <button mat-menu-item
                                [disabled]="isTeilgebietSelected(teilgebiet)"
                                (click)="selectTeilgebiet(teilgebiet)">
                            {{ teilgebiet.teilgebiet }}
                        </button>
                    }
                </mat-menu>
            } @else {
                <button matButton="filled"
                        data-qa="menu-login-button"
                        (click)="login()">
                    <mat-icon>launch</mat-icon>
                    <span>Zum Login</span>
                </button>
            }

        </nav>
    </div>
</header>
